import { Component } from "@angular/core";
import { AdElDirective } from "../../directives/ad-el/ad-el.directive";

/**
 * Apex Logo
 *
 * The Apex brand mark, rendered as a plain `<img>` so the browser keeps
 * it as a vector at any pixel density (no CSS-mask rasterization). The
 * accent fill is baked into the SVG file itself; both current placements
 * (nav, footer) render the mark in accent, so dynamic tinting isn't
 * required. Source asset: `design/client/src/assets/apex-logo.svg`.
 */
@Component({
  selector: "apex-logo",
  templateUrl: "./apex-logo.component.html",
  styleUrls: ["./apex-logo.component.scss"],
  host: { adComp: "" },
  imports: [AdElDirective],
})
export class ApexLogoComponent {}
